///<reference path="node_modules/@types/node/index.d.ts"/>

export {EDCClient, EDCClientConfiguration} from './clients/EDCClient';